import React from 'react'

import appleImg from '../img/iOSStoreImage.png'

import bookImg from "../img/typescript-acc-cover.png"
import appImg from "../img/ts-acc-app.png"
import appImg2 from "../img/ts-acc-app2.png"
import StoreLinks from "./storeLinks";

const title = "TypeScript Accelerated";

const Formats = () => <div className="formats">

  <div>
    <h2>The Book</h2>

    <img src={bookImg} style={{paddingBottom: 38}} />

    <p>Like something traditional? A concise, clear introduction to TypeScript.</p>

    <p>The books are free and should work great on e-readers like a Kindle.</p>

    <a href="https://s3.eu-west-2.amazonaws.com/elm-accelerated-downloads/TypeScriptAccelerated.epub" alt={`${title} epub`}><div className="webLink">ePub</div></a>

    <a href="https://s3.eu-west-2.amazonaws.com/elm-accelerated-downloads/TypeScriptAccelerated.mobi" alt={`${title} mobi`}><div className="webLink">Mobi</div></a>

  </div>

  <div>
    <h2>The App</h2>

    <img src={appImg2} />

    <p>An innovative approach to learning programming. The App has over 50 flash cards and tracks your fluency at each individually. When you have a few minutes spare the App allows you to quickly drill flash cards, focusing on those you are struggling with.</p>


  </div>

  <div>
    <img src={appImg} style={{paddingTop: 78}}/>

    <p>It includes the full book text so you can look up anything you are struggling with. Don't just learn TypeScript, get fluent at it.</p>

    <StoreLinks iOSStoreLink="https://itunes.apple.com/us/app/typescript-accelerated/id1404381952?ls=1&mt=8"/>

  </div>

</div>

export default Formats;


// WEBPACK FOOTER //
// ./src/components/FormatsTS.js